import { Component, Prop, Watch } from "vue-property-decorator";
import InputDefaultForm from "../../default/InputDefaultForm";
import { InputOption, KeyValue } from "../../../../models/Input";
import { CommuneDto } from "../../../../../dto/GenApi.iNotPaie.Dto/CommuneDto";

@Component
export default class AutoCompleteForm extends InputDefaultForm {
	@Prop({
		default: {
			vmodel: "",
			display: "",
			reset: false,
			clear: false,
			error: false,
			counter: false,
			disabled: false,
			height: 0,
			icon: "",
			max: 0,
			message: "",
			label: "",
			sub: false,
			required: false,
			trigger: false
		}
	})
	public dataInputOption!: InputOption;

	@Prop({
		default: {
			vmodel: "",
			display: "",
			reset: false,
			clear: false,
			error: false,
			counter: false,
			disabled: false,
			height: 0,
			icon: "",
			max: 0,
			message: "",
			label: "",
			sub: false,
			required: false,
			trigger: false
		}
	})
	public dataInputOptionLink!: InputOption;

	@Prop()
	public listOption!: KeyValue[];

	@Prop()
	public listOptionRaw!: CommuneDto[];

	@Prop()
	public isLink = false;

	@Prop()
	public isCP = false;

	@Prop()
	public valueIsKey = false;

	public listOptionDisplay: KeyValue[] = [];

	@Prop()
	public noResult = false;

	@Prop({ default: false })
	public isSaisieLibre: boolean = false;

	public isAppear = false;

	public refreshEvent = false;

	public haveClicked = false;

	public mounted(): void {
		this.$forceUpdate();
	}

	@Watch("dataInputOption.trigger")
	public checkValidation(): void {
		this.checkValidationDefault();
		this.$forceUpdate();
	}

	public clickOutside(): void {
		this.close();
	}

	private close(): void {
		this.isAppear = false;
		this.isFocused = false;
		this.refreshEvent = !this.refreshEvent;
	}

	public click(event: any, item: KeyValue): void {
		if (item === undefined) {
			this.dataInputOption.vmodel = "";
			this.dataInputOption.display = "";
			this.success = false;
		} else {
			this.setValue(item);
		}

		this.dataInputOption.message = "";
		this.dataInputOption.error = false;
		this.close();
	}

	@Watch("isFocused")
	public switchMenu(): void {
		this.$emit("isFocused", this.isFocused);
	}

	@Watch("isAppear")
	private watchIsAppear(): void {
		setTimeout(() => {
			this.refreshEvent = !this.refreshEvent;
		}, (this.isAppear) ? 0 : 200);
	}

	public keydown(e: any): void {
		if (e.code === "Tab") {
			this.isAppear = false;
		}
	}

	public keyup(e: any): void {
		if (e.code === "Tab") {
			this.isAppear = false;
		} else if (e.target.value.length >= 3) {
			this.search(e.target.value);
			this.refreshEvent = !this.refreshEvent;
			this.isAppear = true;
		} else {
			this.isAppear = false;
		}
	}

	public search(item: string): void {
		this.listOptionDisplay = [];
		let list: CommuneDto[] = [];

		if(this.isLink) {
			if (Number(item)) {
				list = this.listOptionRaw.filter(commune => commune.CodePostal?.indexOf(item) === 0);
			} else {
				list = this.listOptionRaw.filter(commune => commune.Libelle?.indexOf(item.toUpperCase()) === 0);
			}

			for (let i = 0; i < list.length; i++) {
				this.listOptionDisplay.push({
					key: list[i].Id.toString()!,
					value: list[i].LibelleCodePostale!
				});
			}

			this.noResult = this.listOptionDisplay.length <= 0;
		} else {
			if (Number(item)) {
				this.listOptionDisplay = this.listOption.filter(search => search.value.toUpperCase()?.indexOf(item.toUpperCase()) === 0);
			} else {
				this.listOptionDisplay = this.listOption.filter(search => search.value.toUpperCase()?.indexOf(item.toUpperCase()) >= 0);
			}

			this.noResult = this.listOptionDisplay.length <= 0;
		}

		this.$forceUpdate();
	}

	public blur(e: any): void {
		if (!this.haveClicked) {
			if (!this.isSaisieLibre) {
				this.clearField();
			}
			this.$emit("changed");
		}
	}

	@Watch("dataInputOption.vmodel")
	public watchSelectVmodel(): void {

		if (this.dataInputOption.vmodel !== "") {

			if (this.isSaisieLibre) {

				this.dataInputOption.display = this.dataInputOption.vmodel;

			} else if (this.isLink) {
				let resultCommune: CommuneDto;

				if (Number(this.dataInputOption.vmodel)) {
					resultCommune = this.listOptionRaw.filter(commune => commune.CodePostal === this.dataInputOption.vmodel)?.[0];
				} else {
					resultCommune = this.listOptionRaw.filter(commune => commune.Libelle === this.dataInputOption.vmodel)?.[0];
				}

				if (resultCommune !== undefined) {
					if (this.isCP) {
						this.dataInputOption.vmodel = resultCommune.CodePostal!;
						this.dataInputOption.display = resultCommune.CodePostal;
					} else {
						this.dataInputOption.vmodel = resultCommune.Libelle!;
						this.dataInputOption.display = resultCommune.Libelle;
					}
				} else {
					if (this.isCP) {
						this.dataInputOption.vmodel = "";
						this.dataInputOption.display = "";
					} else {
						this.dataInputOption.vmodel = "";
						this.dataInputOption.display = "";
					}
				}
			} else {
				if (this.listOption !== undefined && this.listOption.length > 0) {

					const result = this.listOption.filter(item => item.key === this.dataInputOption.vmodel)?.map(item => item.value)?.[0];

					if (result === undefined) {
						this.dataInputOption.vmodel = "";
						this.dataInputOption.display = "";
					} else {
						this.dataInputOption.display = result;
					}
				}
			}
		}
		else {
			this.dataInputOption.vmodel = "";
			this.dataInputOption.display = "";
		}
	}

	public setValue(item: KeyValue): void {
		if(this.isLink) {
			const resultCommune = this.listOptionRaw.filter(search => search.Id.toString()?.indexOf(item.key) === 0)[0];

			if(this.isCP) {
				this.dataInputOption.vmodel = resultCommune.CodePostal!;
				this.dataInputOption.display = resultCommune.CodePostal;

				this.dataInputOptionLink.vmodel = resultCommune.Libelle!;
				this.dataInputOptionLink.display = resultCommune.Libelle;
			} else {
				this.dataInputOption.vmodel = resultCommune.Libelle!;
				this.dataInputOption.display = resultCommune.Libelle;

				this.dataInputOptionLink.vmodel = resultCommune.CodePostal!;
				this.dataInputOptionLink.display = resultCommune.CodePostal;
			}
		} else if(this.valueIsKey) {
			this.dataInputOption.vmodel = item.value;
			this.dataInputOption.display = item.value;
		} else {
			this.dataInputOption.vmodel = item.key;
			this.dataInputOption.display = item.value;
		}

		this.dataInputOption.error = false;
		this.dataInputOption.message = "";

		this.dataInputOption.error = false;
		this.dataInputOption.message = "";

		this.$emit("changed");
		this.$forceUpdate();
	}

	public clearField(): void {
		this.dataInputOption.vmodel = "";
		this.dataInputOption.display = "";
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/forms/extended/AutoCompleteForm/AutoCompleteForm.ts